import SellersView from "../SellersView.vue";
import SellersList from "../Pages/SellersList.vue";
import SellersEditor from "../Pages/SellersEditor.vue";

const routes = [
  {
    path: 'vendedores',
    component: SellersView,
    children: [
      {
        path: '',
        name: 'celulares-sellers-list',
        roles: ['cargos_vendedores'],
        component: SellersList,
      },
      {
        path: 'crear',
        name: 'celulares-sellers-create',
        roles: ['cargos_vendedores_agregar'],
        component: SellersEditor
      },
      {
        path: ':id/editar',
        name: 'celulares-sellers-edit',
        roles: ['cargos_vendedores_editar'],
        component: SellersEditor,
      },
    ]
  }
]

export default routes
